import React from 'react';
import Loading from 'components/loading';

import './bizon-checkout.styles.scss';

type LoadingFallbackProps = {
    loading: boolean,
    render?:() => JSX.Element;
};

const LoadingFallback: React.FC<LoadingFallbackProps> = ({ loading, render: Render, children }): JSX.Element => {

    if (loading) {
        return (
            <Loading />
        )
    }

    return (
        <>{Render ? <Render /> : children}</>
    )
};

export default LoadingFallback;
